/* =====================================================================
   Nowar Studio — shared theme behaviours
   Loaded on every page via layout/theme.liquid.
===================================================================== */
(function(){
  'use strict';

  /* ----- Header scroll state ----- */
  var header = document.getElementById('site-header');
  var hero   = document.querySelector('.hero, .hero-cine');
  function onScroll(){
    if (!header) return;
    var threshold = 10;
    if (hero && hero.classList.contains('hero-cine')) {
      threshold = Math.max(0, hero.offsetHeight - 80);
    }
    header.classList.toggle('scrolled', window.scrollY > threshold);

    // Newsletter FAB reveals once the Philosophy (or first non-hero) section enters view
    var nlFab = document.getElementById('nl-fab');
    var trigger = document.querySelector('[data-nl-trigger]');
    if (nlFab) {
      // Pages without a marker still need a reachable newsletter launcher.
      var triggerTop = trigger ? trigger.getBoundingClientRect().top :
        (hero ? hero.getBoundingClientRect().bottom : window.innerHeight - window.scrollY);
      nlFab.classList.toggle('show', triggerTop < window.innerHeight * 0.85);
    }
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll();

  /* ----- Reveal on scroll ----- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, {threshold:0.08});
    document.querySelectorAll('.reveal, .post, .cell').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.reveal, .post, .cell').forEach(function(el){ el.classList.add('in'); });
  }

  /* ----- Mobile drawer ----- */
  var drawer = document.getElementById('mobile-drawer');
  var toggleBtn = document.querySelector('[data-drawer-open]');
  var drawerPanel = drawer && drawer.querySelector('.drawer__panel');
  var drawerPreviousFocus = null;

  function closeMobileDrawer(restoreFocus){
    if (!drawer || !drawer.classList.contains('open')) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('drawer-lock');
    if (restoreFocus !== false && drawerPreviousFocus && drawerPreviousFocus.focus) drawerPreviousFocus.focus();
  }

  function openMobileDrawer(){
    if (!drawer) return;
    drawerPreviousFocus = document.activeElement;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('drawer-lock');
    window.requestAnimationFrame(function(){
      var closeButton = drawer.querySelector('.drawer__close');
      if (closeButton) closeButton.focus();
      else if (drawerPanel) drawerPanel.focus();
    });
  }

  if (drawer && toggleBtn) {
    toggleBtn.addEventListener('click', openMobileDrawer);
    drawer.querySelectorAll('[data-drawer-close]').forEach(function(el){
      el.addEventListener('click', function(){ closeMobileDrawer(true); });
    });
    document.addEventListener('keydown', function(event){
      if (event.key === 'Escape' && drawer.classList.contains('open')) closeMobileDrawer(true);
    });

    var mobileCountrySelector = drawer.querySelector('[data-mobile-country-selector]');
    if (mobileCountrySelector) {
      mobileCountrySelector.addEventListener('change', function(){
        if (mobileCountrySelector.form) mobileCountrySelector.form.submit();
      });
    }
  }

  /* ----- Currency: native link to localization form (if present) ----- */
  var curWrap = document.getElementById('currency-wrap');
  var curBtn  = document.getElementById('currency-btn');
  if (curWrap && curBtn && !curBtn.disabled) {
    var curMenu = curWrap.querySelector('.currency-menu');
    var countrySearch = curWrap.querySelector('[data-country-search]');
    var countryOptions = Array.prototype.slice.call(curWrap.querySelectorAll('[data-country-option]'));
    var countryEmpty = curWrap.querySelector('[data-country-empty]');

    function filterCountries(){
      var query = countrySearch ? countrySearch.value.trim().toLocaleLowerCase() : '';
      var visibleCount = 0;
      countryOptions.forEach(function(option){
        var matches = !query || (option.dataset.searchText || '').toLocaleLowerCase().indexOf(query) !== -1;
        option.hidden = !matches;
        if (matches) visibleCount += 1;
      });
      if (countryEmpty) countryEmpty.hidden = visibleCount !== 0;
    }

    function closeCurrencyMenu(restoreFocus){
      curWrap.classList.remove('open');
      curBtn.setAttribute('aria-expanded', 'false');
      if (countrySearch) {
        countrySearch.value = '';
        filterCountries();
      }
      if (restoreFocus) curBtn.focus();
    }

    curBtn.addEventListener('click', function(e){
      e.stopPropagation();
      var isOpen = curWrap.classList.toggle('open');
      curBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen && countrySearch) countrySearch.focus();
    });
    if (curMenu) curMenu.addEventListener('click', function(e){ e.stopPropagation(); });
    if (countrySearch) countrySearch.addEventListener('input', filterCountries);
    curWrap.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && curWrap.classList.contains('open')) closeCurrencyMenu(true);
    });
    document.addEventListener('click', function(){
      closeCurrencyMenu(false);
    });
  }

  /* ----- Bag drawer ----- */
  var cartDrawer = document.getElementById('cart-drawer');
  var cartLinks = Array.prototype.slice.call(document.querySelectorAll('[data-cart-drawer-trigger]'));
  var cartDrawerPanel = cartDrawer && cartDrawer.querySelector('.cart-drawer__panel');
  var cartDrawerItems = cartDrawer && cartDrawer.querySelector('[data-cart-drawer-items]');
  var cartDrawerStatus = cartDrawer && cartDrawer.querySelector('[data-cart-drawer-status]');
  var cartDrawerSubtotal = cartDrawer && cartDrawer.querySelector('[data-cart-drawer-subtotal]');
  var cartDrawerSubtotalWrap = cartDrawer && cartDrawer.querySelector('[data-cart-drawer-subtotal-wrap]');
  var cartDrawerNote = cartDrawer && cartDrawer.querySelector('[data-cart-drawer-note]');
  var cartDrawerCheckout = cartDrawer && cartDrawer.querySelector('[data-cart-drawer-checkout]');
  var cartDrawerPreviousFocus = null;
  var cartDrawerStatusTimer = null;

  function cartMoney(cents, currency){
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style:'currency',
        currency: currency || (cartDrawer && cartDrawer.dataset.cartCurrency) || 'EUR'
      }).format(cents / 100);
    } catch(e) {
      return (cents / 100).toFixed(2) + ' ' + (currency || 'EUR');
    }
  }

  function cartDrawerElement(tag, className, text){
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined && text !== null) element.textContent = text;
    return element;
  }

  function cartDrawerChangeButton(text, className, line, quantity, label){
    var button = cartDrawerElement('button', className, text);
    button.type = 'button';
    button.dataset.cartChange = '';
    button.dataset.line = line;
    button.dataset.quantity = quantity;
    button.setAttribute('aria-label', label);
    return button;
  }

  function renderCartDrawer(cart){
    if (!cartDrawerItems) return;
    cartDrawerItems.replaceChildren();

    if (!cart.items || !cart.items.length) {
      var empty = cartDrawerElement('div', 'cart-drawer__empty');
      empty.appendChild(cartDrawerElement('p', '', 'Your bag is empty.'));
      empty.appendChild(cartDrawerElement('span', '', 'Discover the collection and find your piece.'));
      cartDrawerItems.appendChild(empty);
    } else {
      cart.items.forEach(function(item, index){
        var line = index + 1;
        var row = cartDrawerElement('article', 'cart-drawer__item');
        var imageLink = cartDrawerElement('a', 'cart-drawer__image');
        imageLink.href = item.url;
        if (item.image) {
          var image = document.createElement('img');
          image.src = item.image;
          image.alt = item.product_title || item.title || '';
          image.loading = 'lazy';
          imageLink.appendChild(image);
        }

        var info = cartDrawerElement('div', 'cart-drawer__item-info');
        var title = cartDrawerElement('a', 'cart-drawer__item-title', item.product_title || item.title);
        title.href = item.url;
        info.appendChild(title);
        if (item.variant_title && item.variant_title !== 'Default Title') {
          info.appendChild(cartDrawerElement('span', 'cart-drawer__variant', item.variant_title));
        }

        var itemActions = cartDrawerElement('div', 'cart-drawer__item-actions');
        var quantityControls = cartDrawerElement('div', 'cart-drawer__quantity-controls');
        quantityControls.setAttribute('aria-label', 'Quantity for ' + (item.product_title || item.title));
        quantityControls.appendChild(cartDrawerChangeButton(
          '−',
          'cart-drawer__quantity-button',
          line,
          Math.max(0, item.quantity - 1),
          'Decrease quantity of ' + (item.product_title || item.title)
        ));
        quantityControls.appendChild(cartDrawerElement('span', 'cart-drawer__quantity-value', item.quantity));
        quantityControls.appendChild(cartDrawerChangeButton(
          '+',
          'cart-drawer__quantity-button',
          line,
          item.quantity + 1,
          'Increase quantity of ' + (item.product_title || item.title)
        ));
        itemActions.appendChild(quantityControls);
        itemActions.appendChild(cartDrawerChangeButton(
          'Remove',
          'cart-drawer__remove',
          line,
          0,
          'Remove ' + (item.product_title || item.title) + ' from bag'
        ));
        info.appendChild(itemActions);

        row.appendChild(imageLink);
        row.appendChild(info);
        row.appendChild(cartDrawerElement('span', 'cart-drawer__price', cartMoney(item.final_line_price, cart.currency)));
        cartDrawerItems.appendChild(row);
      });
    }

    var hasItems = cart.item_count > 0;
    if (cartDrawerSubtotal) cartDrawerSubtotal.textContent = cartMoney(cart.total_price, cart.currency);
    if (cartDrawerSubtotalWrap) cartDrawerSubtotalWrap.hidden = !hasItems;
    if (cartDrawerNote) cartDrawerNote.hidden = !hasItems;
    if (cartDrawerCheckout) cartDrawerCheckout.hidden = !hasItems;

    document.querySelectorAll('[data-cart-count]').forEach(function(count){
      count.textContent = cart.item_count;
    });
  }

  function updateCartDrawerLine(line, quantity){
    if (!cartDrawerPanel) return;
    cartDrawerPanel.setAttribute('aria-busy', 'true');
    fetch('/cart/change.js', {
      method:'POST',
      headers:{'Accept':'application/json', 'Content-Type':'application/json'},
      body:JSON.stringify({line:line, quantity:quantity})
    })
      .then(function(response){
        if (!response.ok) throw new Error('Unable to update bag');
        return response.json();
      })
      .then(function(cart){
        renderCartDrawer(cart);
        bumpCart();
        cartDrawerPanel.removeAttribute('aria-busy');
      })
      .catch(function(){
        cartDrawerPanel.removeAttribute('aria-busy');
      });
  }

  function closeCartDrawer(){
    if (!cartDrawer || !cartDrawer.classList.contains('open')) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartLinks.forEach(function(cartLink){ cartLink.setAttribute('aria-expanded', 'false'); });
    document.body.classList.remove('cart-drawer-lock');
    if (cartDrawerPreviousFocus && cartDrawerPreviousFocus.focus) cartDrawerPreviousFocus.focus();
  }

  function openCartDrawer(options){
    if (!cartDrawer) return Promise.resolve();
    options = options || {};
    cartDrawerPreviousFocus = document.activeElement;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartLinks.forEach(function(cartLink){ cartLink.setAttribute('aria-expanded', 'true'); });
    document.body.classList.add('cart-drawer-lock');

    if (cartDrawerStatus) {
      window.clearTimeout(cartDrawerStatusTimer);
      cartDrawerStatus.textContent = options.announce ? 'Added to your bag' : 'Your selection';
      if (options.announce) {
        cartDrawerStatusTimer = window.setTimeout(function(){
          cartDrawerStatus.textContent = 'Your selection';
        }, 3000);
      }
    }

    window.requestAnimationFrame(function(){
      var closeButton = cartDrawer.querySelector('.cart-drawer__close');
      if (closeButton) closeButton.focus();
    });

    return fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(response){
        if (!response.ok) throw new Error('Unable to load bag');
        return response.json();
      })
      .then(renderCartDrawer)
      .catch(function(){});
  }

  if (cartDrawer) {
    cartDrawer.querySelectorAll('[data-cart-drawer-close]').forEach(function(element){
      element.addEventListener('click', closeCartDrawer);
    });
    document.addEventListener('keydown', function(event){
      if (event.key === 'Escape' && cartDrawer.classList.contains('open')) closeCartDrawer();
    });
    cartDrawer.addEventListener('click', function(event){
      var control = event.target.closest('[data-cart-change]');
      if (!control || !cartDrawer.contains(control) || cartDrawerPanel.hasAttribute('aria-busy')) return;
      var line = Number(control.dataset.line);
      var quantity = Number(control.dataset.quantity);
      if (!line || quantity < 0) return;
      updateCartDrawerLine(line, quantity);
    });
  }

  cartLinks.forEach(function(cartLink){
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.setAttribute('aria-expanded', 'false');
    cartLink.addEventListener('click', function(event){
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      closeMobileDrawer(false);
      openCartDrawer();
    });
  });

  /* ----- PDP: accordion rows + variant selector ----- */
  document.querySelectorAll('[data-pdp-row]').forEach(function(row){
    row.addEventListener('click', function(){
      row.classList.toggle('open');
      var body = row.nextElementSibling;
      if (body && body.classList.contains('pdp__rowBody')) body.classList.toggle('open');
    });
  });

  /* ----- PDP: product films ----- */
  function initialiseProductVideos(root){
    (root || document).querySelectorAll('[data-product-video]').forEach(function(slot){
      if (slot.dataset.videoInitialised === 'true') return;

      var video = slot.querySelector('video');
      if (!video) return;

      slot.dataset.videoInitialised = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;

      var requestedFrame = Math.max(0, parseFloat(slot.dataset.coverFrame) || 0);
      var isThemeEditor = Boolean(window.Shopify && window.Shopify.designMode);
      var startPlayback = function(){
        if (isThemeEditor) return;
        var playPromise = video.play();
        if (playPromise && playPromise.catch) playPromise.catch(function(){});
      };
      var showSelectedFrameAndPlay = function(){
        var latestStart = Number.isFinite(video.duration) ? Math.max(0, video.duration - 0.1) : requestedFrame;
        var selectedFrame = Math.min(requestedFrame, latestStart);

        if (selectedFrame > 0 && Math.abs(video.currentTime - selectedFrame) > 0.05) {
          if (!isThemeEditor) video.addEventListener('seeked', startPlayback, {once:true});
          video.currentTime = selectedFrame;
        } else {
          startPlayback();
        }
      };

      if (video.readyState >= 1) {
        showSelectedFrameAndPlay();
      } else {
        video.addEventListener('loadedmetadata', showSelectedFrameAndPlay, {once:true});
      }
    });
  }

  initialiseProductVideos(document);
  document.addEventListener('shopify:section:load', function(event){
    initialiseProductVideos(event.target);
  });

  /* ----- PDP: variant picker ----- */
  function initialiseProductForm(root) {
    if (!root || !root.querySelector) return;
    var form = root.querySelector('#product-form');
    if (!form || form.dataset.nowarProductFormReady === 'true') return;

    var data = null;
    var dataEl = root.querySelector('[data-nowar-product-json]');
    if (dataEl) {
      try { data = JSON.parse(dataEl.textContent); } catch(e) { data = null; }
    }
    data = data || window.__NOWAR_PRODUCT__;
    if (!data || !data.variants || !data.variants.length) return;

    form.dataset.nowarProductFormReady = 'true';
    var scope = form.closest('.pdp') || document;
    var variantInput = form.querySelector('[name="id"]');
    var priceEl      = scope.querySelector('[data-pdp-price]');
    var btnPriceEl   = scope.querySelector('[data-pdp-btn-price]');
    var addBtn       = form.querySelector('[data-pdp-add]');

    function formatMoney(cents, currency){
      currency = currency || (data && data.currency) || 'EUR';
      var value = (cents / 100);
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style:'currency', currency: currency, minimumFractionDigits: value % 1 === 0 ? 0 : 2
        }).format(value);
      } catch(e){
        return value.toFixed(0) + ' ' + currency;
      }
    }

    function pickVariant(){
      if (!data || !data.variants || !data.variants.length) return null;
      var numOptions = data.variants[0].options.length;
      var selected = [];
      for (var i = 0; i < numOptions; i++) {
        var btn = form.querySelector('button[data-option-index="'+i+'"].active');
        if (btn) { selected[i] = btn.dataset.value; continue; }
        var sel = form.querySelector('select[data-option-index="'+i+'"]');
        if (sel) { selected[i] = sel.value; continue; }
        selected[i] = null;
      }
      return data.variants.find(function(v){
        return v.options.every(function(opt, i){ return selected[i] === opt; });
      }) || null;
    }

    function updateVariant(){
      var v = pickVariant();
      if (!v) return;
      variantInput.value = v.cartId || v.id;
      if (priceEl)    priceEl.textContent    = formatMoney(v.price);
      if (btnPriceEl) btnPriceEl.textContent = formatMoney(v.price);
      if (addBtn) {
        var addBtnText = addBtn.querySelector('span');
        if (addBtnText && !addBtn.dataset.originalText) addBtn.dataset.originalText = addBtnText.textContent;
        if (v.available) {
          addBtn.removeAttribute('disabled');
          if (addBtnText && addBtn.dataset.originalText) addBtnText.textContent = addBtn.dataset.originalText;
        } else {
          addBtn.setAttribute('disabled','');
          if (addBtnText) addBtnText.textContent = 'Sold out';
        }
      }

      if (window.history && window.history.replaceState) {
        var variantUrl = new URL(window.location.href);
        variantUrl.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', variantUrl.toString());
      }
    }

    form.querySelectorAll('[data-option-selector]').forEach(function(el){
      if (el.tagName === 'BUTTON') {
        el.addEventListener('click', function(){
          if (el.classList.contains('oos')) return;
          var idx = el.dataset.optionIndex;
          form.querySelectorAll('button[data-option-index="'+idx+'"]').forEach(function(b){
            b.classList.remove('active');
            b.setAttribute('aria-checked', 'false');
          });
          el.classList.add('active');
          el.setAttribute('aria-checked', 'true');
          updateVariant();
        });
      } else {
        el.addEventListener('change', updateVariant);
      }
    });

    form.addEventListener('submit', function(e){
      if (form.dataset.prelaunchProduct === 'true') return;
      e.preventDefault();
      var v = pickVariant();
      if (!v || !v.available) return;
      var fd = new FormData(form);
      fetch('/cart/add.js', { method:'POST', headers:{'Accept':'application/json'}, body: fd })
        .then(function(r){
          if (!r.ok) throw new Error('Unable to add item');
          return r.json();
        })
        .then(function(){
          var btnText = addBtn.querySelector('span');
          var prev = btnText.textContent;
          btnText.textContent = 'Added to bag';
          bumpCart();
          openCartDrawer({announce:true});
          setTimeout(function(){ btnText.textContent = prev; }, 1400);
        })
        .catch(function(){ /* silent */ });
    });

    updateVariant();
  }

  initialiseProductForm(document);
  document.addEventListener('shopify:section:load', function(event){
    initialiseProductForm(event.target);
  });

  /* ----- Cart count (live) ----- */
  function fetchCartCount(){
    var cartCounts = document.querySelectorAll('[data-cart-count]');
    if (!cartCounts.length) return;
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        cartCounts.forEach(function(el){ el.textContent = cart.item_count; });
      })
      .catch(function(){});
  }
  function bumpCart(){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      if (!el.animate) return;
      el.animate(
        [{transform:'scale(1)'},{transform:'scale(1.25)'},{transform:'scale(1)'}],
        {duration:400,easing:'cubic-bezier(.22,.61,.36,1)'}
      );
    });
  }
  fetchCartCount();

  /* ----- Size guide modal ----- */
  var sg = document.getElementById('size-guide');
  if (sg) {
    document.querySelectorAll('[data-size-guide-open]').forEach(function(el){
      el.addEventListener('click', function(e){ e.preventDefault(); sg.classList.add('open'); });
    });
    sg.addEventListener('click', function(e){
      if (e.target === sg || e.target.hasAttribute('data-modal-close')) sg.classList.remove('open');
    });
  }

})();
